<template>
    <img class="w-auto" :alt="$site_name.value" :src="logoPath" />
</template>

<script>
export default {
    props: {
        theme: {
            default: 'light',
            type: String
        }
    },
    computed: {
        logoPath() {
            return '/images/logos/' + (this.$trusted_checks.value ? 'trusted-checks/' : '/') + this.theme + '.svg';
        }
    }
}
</script>
